import { ItemType } from '@/features/pos/components/ProductCatalog/parts/ProductList/constants'
import { Item } from '@/features/pos/components/ProductCatalog/parts/ProductList/types'
import { FlashList } from '@shopify/flash-list'
import { RefObject, useEffect } from 'react'

export const useScrollToSubcategory = (
    ref: RefObject<FlashList<Item> | null>,
    items: readonly Item[],
    subcategoryId?: string
): void => {
    useEffect(() => {
        const index = items.findIndex(
            (item) => item && item.type === ItemType.Header && item.id === subcategoryId
        )

        if (index >= 0) ref.current?.scrollToIndex({ index, animated: true })
    }, [ref, items, subcategoryId])
}
